import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";
import { IIcon } from "./icons-interfaces";

const NoChannelsSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 170 170">
    <polygon
      fill="#323a42"
      points="16.15 36.37 16.33 120.43 139.93 120.43 139.93 35.81 78.23 86.25 16.15 36.37"
    />
    <g fill="#fff">
      <path d="M78.08,86.56c-.09,0-.18-.03-.25-.09L15.91,36.37c-.13-.11-.18-.28-.12-.44.05-.16.2-.26.37-.26l123.94-.61c.13-.04.32.1.37.26.06.16,0,.33-.12.44l-62.01,50.71c-.07.06-.16.09-.25.09ZM17.26,36.46l60.82,49.2,60.9-49.8-121.72.6Z" />
      <polygon points="140.26 120.09 88.04 78.1 88.53 77.49 140.75 119.47 140.26 120.09" />
      <rect x="8.87" y="98.75" width="66.31" height=".79" transform="translate(-53.75 49.92) rotate(-39.82)" />
      <path d="M16.57,120.78c-.22,0-.39-.18-.39-.39l-.42-84.32c0-.1.04-.2.11-.28.07-.07.17-.12.28-.12l123.94-.61c.15.02.2.04.28.11.07.07.12.17.12.28l.41,84.32c0,.22-.17.39-.39.4l-123.94.61h0ZM16.55,36.46l.41,83.54,123.15-.61-.41-83.53-123.15.6Z" />
      <circle cx="132.76" cy="115.74" r="30.45" />
    </g>
    <g fill="#231f20">
      <path d="M123.2,134.71c-2.2,0-4.4-.84-6.08-2.51l-.39-.39c-3.35-3.35-3.35-8.81,0-12.16l8.91-8.9c3.35-3.35,8.81-3.35,12.16,0l.39.39c.71.71,1.29,1.54,1.72,2.45.37.79.03,1.72-.76,2.09-.79.37-1.73.03-2.09-.76-.27-.58-.64-1.1-1.09-1.55l-.39-.39c-2.12-2.12-5.58-2.12-7.71,0l-8.91,8.9c-2.13,2.13-2.13,5.58,0,7.71l.39.39c2.13,2.13,5.58,2.13,7.71,0l3.74-3.74c.61-.61,1.61-.61,2.23,0,.61.61.61,1.61,0,2.23l-3.74,3.74c-1.68,1.68-3.88,2.51-6.08,2.51Z" />
      <path d="M133.25,124.67c-2.2,0-4.4-.84-6.08-2.51l-.39-.39c-.77-.77-1.37-1.65-1.8-2.64-.35-.8.02-1.72.81-2.07.8-.35,1.73.02,2.07.81.27.63.66,1.19,1.14,1.68l.39.39c2.13,2.12,5.59,2.13,7.71,0l8.9-8.91c1.03-1.03,1.6-2.4,1.6-3.85s-.57-2.83-1.6-3.85l-.39-.39c-2.12-2.12-5.58-2.12-7.71,0l-3.69,3.69c-.61.61-1.61.61-2.23,0s-.61-1.61,0-2.23l3.69-3.69c3.35-3.35,8.81-3.35,12.16,0l.39.39c3.35,3.35,3.35,8.81,0,12.16l-8.9,8.91c-1.68,1.68-3.88,2.51-6.08,2.51Z" />
    </g>
  </svg>
);

const NoChannelsIcon: FunctionComponent<IIcon> = (props): JSX.Element => (
  <Icon className={props.className} component={NoChannelsSvg} />
);

export default NoChannelsIcon;
